const worksLayout = [
  {
    title: 'Kieka Website',
    accomplishment: ['Responsive Web Design', 'Built with Bootstrap 4'],
    img: 'Layout-Kieka-desktop.png',
    mobileImg: 'Layout-Kieka-mobile.png',
    link: 'https://weichieh123.github.io/html-css-bootstrap/kieka/index.html',
    website: 'https://weichieh123.github.io/html-css-bootstrap/kieka/index.html',
    github: 'https://github.com/weichieh123/html-css-bootstrap/tree/main/kieka',
    tags: ['Html', 'CSS', 'Bootstrap', 'RWD'],
    rwd: true,
    content: '切版練習，以Html架構切出Kieka RWD網頁。',
    isFlip: false,
  },
  {
    title: 'Verse Website',
    accomplishment: ['Responsive Web Design', 'Built with Bootstrap 4'],
    img: 'Layout-Verse-desktop.png',
    mobileImg: 'Layout-Verse-mobile.png',
    link: 'https://weichieh123.github.io/html-css-bootstrap/verse/index.html',
    website: 'https://weichieh123.github.io/html-css-bootstrap/verse/index.html',
    github: 'https://github.com/weichieh123/html-css-bootstrap/tree/main/verse',
    tags: ['Html', 'CSS', 'Bootstrap', 'RWD'],
    rwd: true,
    content: '切版練習，以Html架構切出Verse RWD網頁。',
    isFlip: false,
  },
];

export default worksLayout;
